import { render, staticRenderFns } from "./record-kpi-filter.vue?vue&type=template&id=2e2bbf13&scoped=true"
import script from "./record-kpi-filter.vue?vue&type=script&lang=js"
export * from "./record-kpi-filter.vue?vue&type=script&lang=js"
import style0 from "./record-kpi-filter.vue?vue&type=style&index=0&id=2e2bbf13&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2bbf13",
  null
  
)

export default component.exports